import { Directive, Input, SimpleChanges } from '@angular/core';
import { Validator, AbstractControl, NG_VALIDATORS, ValidatorFn } from '@angular/forms';

export function ArrayLengthNotLarger(max:number): ValidatorFn {
  return (control: AbstractControl): {[key: string]: any} => {
    return control.value?(control.value.split(",").length > max ? {'appArrayLengthNotLarger': {value: control.value}} : null) : null;
  };
}

@Directive({
  selector: '[appArrayLengthNotLarger]',
  providers: [{provide: NG_VALIDATORS, useExisting: ArrayLengthNotLargerDirective, multi: true}]
})
export class ArrayLengthNotLargerDirective {
  @Input('appArrayLengthNotLarger') max: number;
 
  validate(control: AbstractControl): {[key: string]: any} {
    return this.max ? ArrayLengthNotLarger(this.max)(control)
                              : null;
  }

  registerOnValidatorChange(fn: () => void): void { this._onChange = fn; }
  private _onChange: () => void;

  ngOnChanges(changes: SimpleChanges): void {
 
    if ('max' in changes) {
      
      if (this._onChange) this._onChange();
    }
  }

}
